const images = {
  registerImage: "/Images/Register/register.png",
  logoimg: "/Images/Logo/chatapplogo.png",
  backGroundImg: "/Images/BackgroundImg/background.jpg",
  userDemo: "Images/Other_images/User_img.jpg",
  notDataFound: "Images/NotFound/Not Found.png",
  notChatFound: "Images/NotFound/nochat.png",
  notConvFound: "Images/NotFound/noselectedconv.png",
  noCompanyFound: "Images/Other_images/office.png",
  group: "Images/Other_images/people.png",
  changepassword: "Images/AuthPassword/resetpassword.png",
  forgotpassword: "Images/AuthPassword/forgotpassword.png",
  unauthrize: "Images/NotFound/404.png",
  // word: "Images/Icons/word.png",
  // pdf: "Images/Icons/pdf.png",
  // excel: "Images/Icons/excel.png",
  // powerpoint: "Images/Icons/powerpoint.png",
};
export default images;
